<template>
  <span class="has-text-weight-bold" :class="presenter.class">{{ presenter.label }}</span>
</template>

<script>
export default {
  computed: {
    presenter () {
      const presenter = {}
      if (this.role.suspended_at) {
        presenter.class = 'has-text-grey-light'
        presenter.label = 'Suspended'
      } else {
        presenter.class = 'has-text-success'
        presenter.label = 'Active'
      }
      return presenter
    }
  },
  props: ['role']
}
</script>
